











































import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";

import { getClassified } from "@/shared/scripts/ClassifiedsApi";
import { getPricing } from "@/shared/scripts/PricingApi";
import { Trans } from "@/shared/scripts/helpers/translation/translation";
import { Classified } from "@/shared/interfaces/classified/Classified.interface";
import { Pricing } from "@/shared/interfaces/pricing/pricing.interface";

import iwProgressionWizard from "@/encoding/components/progressionWizard/ProgressionWizard.vue";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { WizardState } from "@/shared/interfaces/WizardState.interface";
import { getVisibilitySteps } from "@/encoding/scripts/steps";
import { configurePacksOnInit } from "@/optimizedEncoding/scripts/packConfig";
import { isEmpty } from "lodash";

export default Vue.extend({
    name: "VisibilityUpgrade",
    components: {
        iwProgressionWizard: iwProgressionWizard,
    },

    props: {
        id: {
            type: String,
            required: true,
            default: "",
        }
    },

    data: function() {
        return {
            isMobile: true as boolean,
            mainSidebarSticky: false as boolean,
            classified: {} as Classified,
            packs: [] as Array<Pricing>,
            mainSidebarIsFixed: false as boolean,
        };
    },

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading"
        }),
        ...mapState("StepsWizard", {
            currentStep: state => (state as WizardState).current,
        }),

        isSuccessStep: function(): boolean {
            return this.$router.currentRoute.name === "visibility-upgrade-confirmation";
        },
    },

    created: async function() {
        this.initWizard({config: getVisibilitySteps()});

        this.classified = this.$store.getters["MyClassifiedsModule/getMyClassifiedSelected"];

        // Fetch classified when direct URL entry (= store 👆 is empty).
        if (isEmpty(this.classified)) {
            this.classified = await this.getClassified();
            this.$store.commit("MyClassifiedsModule/setMyClassifiedSelected", this.classified);
            this.$store.commit("FormModule/setClassifiedId", this.classified.id);
        }

        // /**
        //  * The commits to FormModule below are a workaround to make sure the
        //  * packages preview are properly receiving title and description.
        //  * It should ideally be handled in another way in the future.
        //  */

        // this.$store.dispatch("FormModule/addValue", {
        //     path: `property.title.${Trans.currentLocale}`,
        //     value: this.classified.property.title[Trans.currentLocale],
        // });

        this.$store.dispatch("FormModule/addValue", {
            path: `property.description.${Trans.currentLocale}`,
            value: this.classified.property.description[Trans.currentLocale],
        });

        // getTransactionType() (used below via configurePacksOnInit) reads FormModule's
        // plain "criteria" tree, not "criteriaTransaction" - without this it stays empty/stale
        // here, so isFreeInPack never resolves true and Premium's billboard never defaults on.
        this.$store.dispatch("FormModule/addValue", {
            path: "transaction",
            value: this.classified.transaction,
        });

        if (this.classified.customerId) {
            // Eagerly load the full customer (incl. name) so the order-creation missing-name
            // guard evaluates the real record rather than an {id}-only placeholder. Awaited so
            // it is in place long before the user can click Next, and the failure is swallowed
            // because the guard fails open: it must never block the upgrade funnel from loading.
            await this.$store.dispatch("CustomersModule/setCurrentCustomer", this.classified.customerId)
                .catch(() => undefined);
        }

        this.packs = await this.getPacks();

        const storedPacks = this.$store.getters["FormModule/getValueTransaction"]("transaction.pricing");
        if (storedPacks) {
            const configured = configurePacksOnInit(storedPacks, this.getTransactionType());
            this.$store.commit("FormModule/addValueTransaction", {
                path: "transaction.configuredPacks",
                value: configured,
            });
        }
    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
            this.mainSidebarSticky = true;
        }, () => {
            this.isMobile = true;
            this.mainSidebarSticky = false;
        });
    },

    methods: {
        ...mapActions({
            initValidatedStep: "StepsWizard/validate",
            initWizard: "StepsWizard/init"
        }),
        getPacks: async function(): Promise<Array<Pricing>> {
            return await getPricing({
                classified: this.classified,
                type: "UPGRADE",
            })
                .then(packs => packs)
                .catch(error => {
                    this.dialog.alert(i18n.t("server_not_responding_error").toString());
                    console.error(error);
                    return [];
                });
        },

        getClassified: function(): Promise<Classified> {
            return getClassified(this.id)
                .then(classified => classified)
                .catch(error => {
                    this.dialog.alert(i18n.t("server_not_responding_error").toString());
                    console.error(error);
                    return {} as Classified;
                });
        },

        handleMainSidebarScroll: function() {
            let documentElement = (
                document.scrollingElement ||
                document.documentElement ||
                document.body.parentNode ||
                document.body
            ) as HTMLElement;

            let documentScrollTop = 0;
            if(documentElement) {
                documentScrollTop = documentElement.scrollTop;
            }

            // Top Navigation
            let topNavigation = document.getElementById("main-sidebar");
            if (topNavigation) {
                if (documentScrollTop > 1) {
                    this.mainSidebarIsFixed = true;
                } else {
                    this.mainSidebarIsFixed = false;
                }
            }
        }
    },
});
